import { createFeatureSelector, createSelector } from '@ngrx/store'
import { EVENT_TICKETS_FEATURE_KEY, EventTicketsState, eventTicketsAdapter } from './base-event-tickets.reducer'

// Lookup the 'EventTickets' feature state managed by NgRx
export const selectEventTicketsState = createFeatureSelector<EventTicketsState>(EVENT_TICKETS_FEATURE_KEY)

export const { selectAll, selectEntities } = eventTicketsAdapter.getSelectors()

export const selectEventTicketsLoaded = createSelector(
  selectEventTicketsState,
  (state: EventTicketsState) => state.loaded,
)

export const selectAllEventTickets = createSelector(selectEventTicketsState, (state: EventTicketsState) =>
  selectAll(state),
)

export const selectEventTicketsEntities = createSelector(selectEventTicketsState, (state: EventTicketsState) =>
  selectEntities(state),
)

export const selectSelectedId = createSelector(selectEventTicketsState, (state: EventTicketsState) => state.selectedId)

export const selectedEventTicket = createSelector(
  selectEventTicketsEntities,
  selectSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
)

export const selectAllListLoadedEventTickets = createSelector(selectAllEventTickets, (eventTickets) =>
  eventTickets.filter((eventTicket) => !eventTicket.notListLoaded),
)

export const selectCount = createSelector(selectEventTicketsState, (state: EventTicketsState) => state.count)

export const selectSummary = createSelector(selectEventTicketsState, (state: EventTicketsState) => state.summary)

export const selectLimit = createSelector(selectEventTicketsState, (state: EventTicketsState) => state.limit)

export const selectOffset = createSelector(selectEventTicketsState, (state: EventTicketsState) => state.offset)

export const selectFilters = createSelector(selectEventTicketsState, (state: EventTicketsState) => state.filters)

export const selectedEventTicketCustomFields = createSelector(
  selectedEventTicket,
  (eventTicket) => eventTicket?.ticket_package.custom_fields,
)

export const selectedEventTicketCustomValues = createSelector(
  selectedEventTicket,
  (eventTicket) => eventTicket?.profile?.custom_values,
)

export const selectEventTicketById = (uuid: string) =>
  createSelector(selectEventTicketsEntities, (entities) => entities[uuid])
